"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDmsPasswordExpiration = void 0;
var _react = require("react");
var _sweetalert = _interopRequireDefault(require("sweetalert2"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsTokenHook = require("../components/DmsTokenHook/DmsTokenHook");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useDmsPasswordExpiration = () => {
  (0, _react.useEffect)(() => {
    const handlePasswordExpiration = () => {
      const passwordExpires = (0, _DmsTokenHook.getToken)().password_expires;
      const expirationSwalShow = sessionStorage.getItem("expirationSwalShow");
      if (passwordExpires !== undefined && passwordExpires > -1 && expirationSwalShow === "true") {
        _sweetalert.default.fire({
          title: _reactIntlUniversal.default.get("PasswordExpireTitle").d("Your password will expire soon!"),
          html: _reactIntlUniversal.default.get("PasswordExpireMessageBegin").d("Your password will expire in") + " ".concat(passwordExpires, " ") + _reactIntlUniversal.default.get("PasswordExpireMessageEnd").d("day(s). Please change it or contact the administrator."),
          confirmButtonText: "OK",
          allowOutsideClick: false,
          icon: 'warning'
        }).then(result => {
          if (result.isConfirmed) {
            sessionStorage.setItem("expirationSwalShow", "false");
          }
        });
      }
    };
    handlePasswordExpiration();
  }, []);
};
exports.useDmsPasswordExpiration = useDmsPasswordExpiration;